<div class="container-fluid">
  <div class="row">
    <app-display-counts-widget
      [widgetPanelCounts]="widgetPanelCounts"
      [widgetPanel]="{ style: {} }"
      [title]="'API Errors'"
    ></app-display-counts-widget>
  </div>
</div>
